var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 400,
    viewBox: "0 0 317.49 105.83",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m56.157 102.02h226.37s10.037-16.439-16.728-17.873c0 0-2.5624-0.45477-4.9281 0.55908 0 0 19.179-6.928 11.744-24.839-7.4349-17.911-40.047-11.659-50.862 4.0554 0 0-2.9353 2.6615-3.5798 11.005 0 0-11.369-18.025-25.397-5.855 0 0 2.5319-12.585-13.436-16.387s-30.416 11.068-28.557 22.051c0 0-13.985-15.6-28.453 4.0707 0 0 3.3597-12.773-18.016-22.489 0 0-32.781-12.758-37.597 11.575 0 0-2.9553 14.221 12.463 19.952 0 0-24.295-1.5271-23.028 14.175z",
    fill: "#e0f4fa",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/cloud1.5c476661f28c2af179e6e3191346c30f.svg";
export { ForwardRef as ReactComponent };